<template>
  <div
    v-show="this.$store.state.layout === 'default'"
    class="min-height-300 position-absolute w-100"
    :class="this.$store.state.isDarkMode ? 'bg-transparent' : 'inga-top-wash'"
  />
  <aside
    class="my-3 overflow-auto fixed-start ms-3 border-0 sidenav navbar navbar-vertical navbar-expand-xs border-radius-xl"
    :class="[
      this.$store.state.layout === 'landing' ? 'bg-transparent shadow-none' : '',
      this.$store.state.sidebarType,
      { 'sidenav-theme-dark': this.$store.state.isDarkMode }
    ]"
    id="sidenav-main"
  >
    <div class="sidenav-header">
      <router-link class="m-0 navbar-brand sidenav-brand" to="/">
        <img
          :src="imgRoot + 'inga_logo_small.png'"
          class="sidenav-brand-img"
          alt="INGA"
        />
        <span class="sidenav-brand-text">
          <span class="sidenav-brand-name" :style="brandNameStyle">INGA.CZ</span>
          <span class="sidenav-brand-tagline">Tvoje investiční hra</span>
        </span>
      </router-link>
    </div>
    <hr
      class="mt-0 horizontal dark"
      :style="this.$store.state.isDarkMode ? 'background-color: #2D3748 !important; opacity: 1; border-color: #2D3748 !important;' : ''"
    />
    <sidenav-list :cardBg="custom_class" />
  </aside>
</template>
<script>
import SidenavList from "./SidenavList.vue";

export default {
  name: "index",
  components: {
    SidenavList
  },
  computed: {
    imgRoot() { return process.env.VUE_APP_IMG_ROOT; },
    brandNameStyle() {
      const dark = !!this.$store.state.isDarkMode;
      return {
        fontFamily: "'Arial Black', 'Franklin Gothic Heavy', Roboto, sans-serif",
        fontWeight: 900,
        webkitTextStroke: "0.5px currentColor",
        webkitFontSmoothing: "auto",
        color: dark ? "#F8FAFC" : "#0F172A"
      };
    }
  },
  data() {
    return {
      
    };
  },
  props: ["custom_class", "layout"]
};
</script>

<style>
.sidenav-theme-dark.navbar-vertical.navbar,
.sidenav-theme-dark.navbar-vertical.navbar.bg-white {
  background-color: #0F172A !important;
  --bs-bg-opacity: 1;
  border: 1px solid #334155 !important;
  box-shadow: none !important;
}

.sidenav-brand {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding: 14px 16px 8px 32px !important;
  white-space: normal !important;
  text-align: left;
}

.sidenav-brand-img {
  height: 56px;
  width: auto;
  flex-shrink: 0;
}

.sidenav-brand-text {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  line-height: 1.05;
  min-width: 0;
  width: max-content;
}

#sidenav-main .sidenav-brand-name {
  font-family: "Arial Black", "Franklin Gothic Heavy", Roboto, sans-serif !important;
  font-size: 1.5rem !important;
  font-weight: 900 !important;
  letter-spacing: 0.02em;
  line-height: 1.1;
  color: #0F172A !important;
  -webkit-text-stroke: 0.5px currentColor;
  paint-order: stroke fill;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}

#sidenav-main.sidenav-theme-dark .sidenav-brand-name {
  color: #F8FAFC !important;
}

.sidenav-brand-tagline {
  margin-top: 3px;
  display: block;
  width: 100%;
  font-family: "Ubuntu Sans", Ubuntu, sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.2;
  color: #FF9966 !important;
  white-space: nowrap;
}

.sidenav-theme-dark .sidenav-brand-name {
  color: #F8FAFC !important;
}

.sidenav-theme-dark .sidenav-brand-tagline {
  color: #FF9966 !important;
}

.sidenav-theme-dark hr.horizontal {
  background-image: linear-gradient(
    to right,
    rgba(45, 55, 72, 0),
    #2D3748,
    rgba(45, 55, 72, 0)
  ) !important;
}
</style>

